import { render, staticRenderFns } from "./BandejaRechazarPTIComponente.vue?vue&type=template&id=6b075d6f"
import script from "./BandejaRechazarPTIComponente.vue?vue&type=script&lang=js"
export * from "./BandejaRechazarPTIComponente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports